import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {Observable} from 'rxjs';
import { Vendor } from '../../model/vendor';
import { environment } from '../../../environments/environment';
import { UserFriendlyMsgs } from '../../app.user-msgs';

@Injectable()
export class VendorsearchService {
  url = environment.configURI;

  constructor(private http: HttpClient,private userFriendlyMsgs: UserFriendlyMsgs) { }

  
 
getVendorEmail(searchBy): Observable<Vendor[]> {
  return this.http.get<Vendor[]>(this.url + '/vendor?searchTerm='+ searchBy).catch(this.userFriendlyMsgs.errorHandler)
  }

}



      


// WEBPACK FOOTER //
// ./src/app/services/vendor/vendorsearch.service.ts